<template>
    <div id="cookieConsent" class="full-width-row p-5 cookie-consent" role="alert" v-show = "showBanner">
        <div class="container">
            <div class="row pt-3 pb-3">
                <div class="col-12 col-lg-9 pt-5 pt-lg-0">
                    <div v-if="blockedRegion === 'true'" id="CookieTextEU">
                        <p> We use cookies and similar technologies to recognize your repeat visits and preferences as well as to measure the effectiveness of campaigns and analyze traffic. To learn more about cookies, you can view our <a href="/privacy-statement/" target="_blank">privacy policy</a> here. By clicking I Accept on this banner, or using our site, you consent to the use of cookies unless you have declined them. </p>

                    </div>
                    <div v-else id="CookieText">
                        <p> We use cookies and similar technologies to recognize your repeat visits and preferences as well as to measure the effectiveness of campaigns and analyze traffic. To learn more about cookies, you can view our <a href="/privacy-statement/" target="_blank">privacy policy</a> here. We comply with the California Consumer Privacy Act of 2018 (CCPA).You can view our <a href="/privacy-statement?#CCPA">California Residents Privacy Rights notice </a>here. By using our site, you consent to the use of cookies and may adjust or decline <a href="javascript:void(0)" @click="showAdvancedSettingsModal()">Cookie Settings</a> here. </p>                    </div>
                </div>
                <div class="col-12 col-lg-3 pt-3 pt-lg-0">
                    <div class="text-center">
                        <button type="button" class="btn btn-cookie-accept mb-2" id="cookie-prompt-accept-btn" @click="acceptAllCookies()">
                            <span aria-hidden="true">{{this.buttonText}}</span>
                        </button>
                        <a v-if="this.blockedRegion === 'true'" href="javascript:void(0)" class="cookie-reject-btn w-100 d-block" id="cookie-prompt-withdraw-btn" @click="showAdvancedSettingsModal()">Cookie Settings</a>
                    </div>
                </div>
                <light-box id="cookieSettingsModal" :show="showAdvancedSettings" @close="hideAdvancedSettingsModal()">
                    <template v-slot:header>
                        <div style="text-align: center;" class="lightbox-title">Cookie Settings</div> 
                    </template>
                    <template v-slot:body>
                        <div v-for="cookieSetting in cookieSettings" :key="cookieSetting.cookieName">
                            <switch-checkbox :label="cookieSetting.label" v-model="cookieSetting.granted" :disabled="cookieSetting.disabled"></switch-checkbox>
                            <p v-html="cookieSetting.description"></p>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <div class="pt-3">
                            <button class="btn-main mb-2 align-top mr-4" @click="saveSettings()">Confirm My Choices</button>
                            <button :class="getButtonClasses" @click="acceptAllCookies()">Accept All Cookies</button>
                        </div>
                    </template>
                </light-box>
                
            </div>
        </div>
    </div>
</template>
<script>
    import CookieHelper from "../../helpers/CookieHelper.js";
    import LightBox from "../atoms/LightBox.vue";
    import SwitchCheckbox from "../atoms/SwitchCheckbox.vue";

    export default {
        name: "CookieBanner",
        props: ['privacyPolicyUrl', 'ccpaStatementUrl','blockedRegion'],
        components: {
            LightBox,
            SwitchCheckbox
        },
        data() {
            return {
                showBanner: false,
                showAdvancedSettings: false,
               
                cookieSettings: [
                    {
                        granted: true,
                        cookieName: "user_essential_cookie_consent",
                        eventPrefix: "on_user_essential_cookie_consent",
                        disabled: true,
                        label: "Essential Cookies",
                        description: "These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. To learn more, view our <a href='" + this.privacyPolicyUrl + "' target='_blank'>Privacy Policy</a>."
                    },
                    {
                        granted: false,
                        cookieName: "user_performance_cookie_consent",
                        eventPrefix: "on_user_performance_cookie_consent",
                        disabled: false,
                        label: "Performance Cookies",
                        description: "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site."
                    },
                    {
                        granted: false,
                        cookieName: "user_functional_cookie_consent",
                        eventPrefix: "on_user_functional_cookie_consent",
                        disabled: false,
                        label: "Functional  Cookies",
                        description: "These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by other companies whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly."
                    },
                    {
                        granted: false,
                        cookieName: "user_social_media_cookie_consent",
                        eventPrefix: "on_user_social_media_cookie_consent",
                        disabled: false,
                        label: "Social Media Cookies",
                        description: "These cookies are set by a range of social media services that we have added to the site to enable you to share our content with your friends and networks. They are capable of tracking your browser across other sites and building up a profile of your interests. This may impact the content and messages you see on other websites you visit. If you do not allow these cookies you may not be able to use or see these sharing tools."
                    }
                ]
            }
        },
        computed: {
            getButtonClasses() {
                var currentBrand = sessionStorage.getItem("brand");
                if (currentBrand === "mastercraft" || currentBrand === "crest") {
                    return "btn btn-outline mb-2 align-top cookie-float-right";
                }
                return "btn btn-outline mb-2 align-top"
            },
            buttonText() {
                return this.blockedRegion === "true" ? "I Accept" : "Close";
            }
        },
        methods: {
            showCookieBanner: function () {
                this.hideAdvancedSettingsModal();
                this.showBanner = true;
            },
            hideCookieBanner: function () {
                this.hideAdvancedSettingsModal();
                this.showBanner = false;
                
            },
            grantConsent: function () {
                CookieHelper.deleteCookie('user_tracking_cookie_consent');
                CookieHelper.setCookie('user_tracking_cookie_consent', 1, 30);
                let cookieAcceptEvent = new Event('on_user_tracking_cookie_consent_granted');
                document.dispatchEvent(cookieAcceptEvent);

                this.hideCookieBanner();
            },
            revokeConsent: function () {
                CookieHelper.deleteCookie('user_tracking_cookie_consent');
                CookieHelper.setCookie('user_tracking_cookie_consent', 0, 30);
                let cookieWithdrawnEvent = new Event('on_user_tracking_cookie_consent_withdrawn');
                document.dispatchEvent(cookieWithdrawnEvent);
                this.hideCookieBanner();
            },
            acceptAllCookies: function() {
                for (var i = 0; i < this.cookieSettings.length; i++) {
                    this.cookieSettings[i].granted = true;
                }

                this.saveSettings();
            },
            saveSettings: function() {
                for (var i = 0; i < this.cookieSettings.length; i++) {
                    this.handleCookie(this.cookieSettings[i].granted, this.cookieSettings[i].cookieName, this.cookieSettings[i].eventPrefix);
                }
                this.hideAdvancedSettingsModal();
                this.showBanner = false;
            },
            handleCookie: function(val, cookieName, eventNamePrefix) {
                CookieHelper.deleteCookie(cookieName);
                if (val === true) {
                    CookieHelper.setCookie(cookieName, 1, 30);
                    let cookieGrantedEvent = new Event(eventNamePrefix + '_granted');
                    document.dispatchEvent(cookieGrantedEvent);
                }
                else {
                    CookieHelper.setCookie(cookieName, 0, 30);
                    let cookieWithdrawnEvent = new Event(eventNamePrefix + '_withdrawn');
                    document.dispatchEvent(cookieWithdrawnEvent);
                }
            },
            showAdvancedSettingsModal: function() {
                this.setValuesFromCookies();
                this.showAdvancedSettings = true;
               
            },
            hideAdvancedSettingsModal: function() {
                this.showAdvancedSettings = false;
            },
            setValuesFromCookies: function() {
                for (var i = 0; i < this.cookieSettings.length; i++) {
                    let cookieValue = CookieHelper.getCookie(this.cookieSettings[i].cookieName);
                    if (cookieValue === "0") {
                        this.cookieSettings[i].granted = false;
                    }
                    if (cookieValue === "1") {
                        this.cookieSettings[i].granted = true;
                    }
                }
            },
            setDefaultCookies: function () {
                if (this.blockedRegion === "false") {
                    
                    for (var i = 0; i < this.cookieSettings.length; i++) {
                        this.cookieSettings[i].granted = true;
                        //console.log(this.cookieSettings[1].granted);
                        this.handleCookie(this.cookieSettings[i].granted, this.cookieSettings[i].cookieName, this.cookieSettings[i].eventPrefix);
                    }
                }
                else {
                    this.cookieSettings[0].granted = true;
                    this.handleCookie(this.cookieSettings[0].granted, this.cookieSettings[0].cookieName, this.cookieSettings[0].eventPrefix);
                    for (var j = 1; j < this.cookieSettings.length; j++) {
                        this.cookieSettings[j].granted = false;                        
                        //console.log(this.cookieSettings[1].granted);
                        this.handleCookie(this.cookieSettings[j].granted, this.cookieSettings[j].cookieName, this.cookieSettings[j].eventPrefix);
                    }
                }
                }
        },
        mounted(){
            let selectedCookieSettings = CookieHelper.getCookie("user_essential_cookie_consent");
            if (selectedCookieSettings == null || selectedCookieSettings == "") {
                this.setValuesFromCookies();
                this.showCookieBanner();
                this.setDefaultCookies();
                
            }
            document.addEventListener("show_cookie_settings", this.showCookieBanner);
        }
    };
</script>